import React from 'react';
import { useParams } from 'react-router-dom';

const VideoConference = () => {
	const { id } = useParams();
	return <div style={{ height: `100vh`, width: "100%" }} >
		<iframe title="Jit Si" width="100%" height="100%" src={`https://meet.jit.si/${id}`} frameborder="0"></iframe>
	</div>;
};

export default VideoConference;